<template functional>
  <dl :class="[data.staticClass,data.class] || ''" v-bind="data.$attrs">
    <dt>{{ props.label }}</dt>
    <dd class="truncate">{{ props.value }}</dd>
  </dl>
</template>

<script>
export default {
  name: "GoalPreviewStatsItem"
}
</script>

<style lang="scss" scoped>
dl {
  @apply flex justify-between;
  font-size: 1.5rem;
  line-height: 2.2rem;

  dt {
    @apply font-bold mr-8;
  }

  &.big {
    font-size: 1.8rem;
  }
  @media(max-width: 1199px){
    font-size: 1.3rem;
    &.big {
      font-size: 1.5rem;
    }
  }
}
</style>